<template>
  <div>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Standard Disc/Comm Rate Information</div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6 v-if="newStdCommDiscRate">
              <v-layout row wrap>
                <v-flex xs7>
                  <cal-picker v-model="effDate" :label="labels.effDate" v-validate="'required'" :data-vv-as="labels.effDate" data-vv-name="effDate" :error-messages="errors.collect('effDate')" @input="doEffDate"></cal-picker>
                </v-flex>
                <v-flex xs5>
                  <time-picker v-model="effTime" :label="labels.effTime" v-validate="'required'" :data-vv-as="labels.effTime" data-vv-name="effTime" :error-messages="errors.collect('effTime')" @input="doEffDate"></time-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{labels.effDateQuery}}</v-subheader>
              <div class="title">{{formatDateTime2(stdCommDiscRateForm.effDate)}}</div>
            </v-flex>
            <v-flex xs6>
              <v-layout row wrap>
                <v-flex xs7>
                  <cal-picker v-model="endDate" :label="labels.endDate" v-validate="endDateValidation" :min="this.effDate" :data-vv-as="labels.endDate" data-vv-name="endDate" :error-messages="errors.collect('endDate')" @input="doEndDate"></cal-picker>
                </v-flex>
                <v-flex xs5>
                  <time-picker v-model="endTime" :label="labels.endTime" :data-vv-as="labels.endTime" data-vv-name="endTime" :error-messages="errors.collect('endTime')" @input="doEndDate"></time-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4 v-if="fact1to3Search(stdCommDiscFactors.fact1) !== null && !newStdCommDiscRate">
                  <v-subheader class="queryLabel">{{fact1to3Search(stdCommDiscFactors.fact1)}}</v-subheader>
                  <div class="title">{{stdCommDiscRateForm.fact1}}</div>
                </v-flex>
                <v-flex xs4 v-if="stdCommDiscFactors.fact1 !== null && newStdCommDiscRate">
                  <v-autocomplete :items="factor1to3ValueListSearch(stdCommDiscFactors.fact1)" v-model="stdCommDiscRateForm.fact1" :label="fact1to3Search(stdCommDiscFactors.fact1)" item-text="label" item-value="value" data-vv-name="fact1" :data-vv-as="labels.fact1" :error-messages="errors.collect('fact1')" v-validate="'required'" :loading="factValueLoading"></v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="fact1to3Search(stdCommDiscFactors.fact2) !== null && !newStdCommDiscRate">
                  <v-subheader class="queryLabel">{{fact1to3Search(stdCommDiscFactors.fact2)}}</v-subheader>
                  <div class="title">{{stdCommDiscRateForm.fact2}}</div>
                </v-flex>
                <v-flex xs4 v-if="stdCommDiscFactors.fact2 !== null && newStdCommDiscRate">
                  <v-autocomplete :items="factor1to3ValueListSearch(stdCommDiscFactors.fact2)" v-model="stdCommDiscRateForm.fact2" :label="fact1to3Search(stdCommDiscFactors.fact2)" item-text="label" item-value="value" data-vv-name="fact2" :data-vv-as="labels.fact2" :error-messages="errors.collect('fact2')" v-validate="'required'" :loading="factValueLoading"></v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="fact1to3Search(stdCommDiscFactors.fact3) !== null && !newStdCommDiscRate">
                  <v-subheader class="queryLabel">{{fact1to3Search(stdCommDiscFactors.fact3)}}</v-subheader>
                  <div class="title">{{stdCommDiscRateForm.fact3}}</div>
                </v-flex>
                <v-flex xs4 v-if="stdCommDiscFactors.fact3 !== null && newStdCommDiscRate">
                  <v-autocomplete :items="factor1to3ValueListSearch(stdCommDiscFactors.fact3)" v-model="stdCommDiscRateForm.fact3" :label="fact1to3Search(stdCommDiscFactors.fact3)" item-text="label" item-value="value" data-vv-name="fact3" :data-vv-as="labels.fact3" :error-messages="errors.collect('fact3')" v-validate="'required'" :loading="factValueLoading"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4 v-if="fact4to6Search(stdCommDiscFactors.fact4) !== null && !newStdCommDiscRate">
                  <v-subheader class="queryLabel">{{fact4to6Search(stdCommDiscFactors.fact4)}}</v-subheader>
                  <div class="title">{{stdCommDiscRateForm.fact4}}</div>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(stdCommDiscFactors.fact4) !== null && newStdCommDiscRate">
                  <v-text-field v-num-mask v-model="stdCommDiscRateForm.fact4" :label="fact4to6Search(stdCommDiscFactors.fact4)" :error-messages="errors.collect('fact4')" data-vv-name="fact4" :data-vv-as="labels.fact4" v-validate="'required'"></v-text-field>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(stdCommDiscFactors.fact5) !== null && !newStdCommDiscRate">
                  <v-subheader class="queryLabel">{{fact4to6Search(stdCommDiscFactors.fact5)}}</v-subheader>
                  <div class="title">{{stdCommDiscRateForm.fact5}}</div>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(stdCommDiscFactors.fact5) !== null && newStdCommDiscRate">
                  <v-text-field v-num-mask v-model="stdCommDiscRateForm.fact5" :label="fact4to6Search(stdCommDiscFactors.fact5)" :error-messages="errors.collect('fact5')" data-vv-name="fact5" :data-vv-as="labels.fact5" v-validate="'required'"></v-text-field>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(stdCommDiscFactors.fact6) !== null && !newStdCommDiscRate">
                  <v-subheader class="queryLabel">{{fact4to6Search(stdCommDiscFactors.fact6)}}</v-subheader>
                  <div class="title">{{stdCommDiscRateForm.fact6}}</div>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(stdCommDiscFactors.fact6) !== null && newStdCommDiscRate">
                  <v-text-field v-num-mask v-model="stdCommDiscRateForm.fact6" :label="fact4to6Search(stdCommDiscFactors.fact6)" :error-messages="errors.collect('fact6')" data-vv-name="fact6" :data-vv-as="labels.fact6" v-validate="'required'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs6>
                  <v-autocomplete :items="gnList" v-model="stdCommDiscRateForm.commGN" :label="labels.commGN" item-text="label" item-value="value" data-vv-name="commGN" :data-vv-as="labels.commGN" :error-messages="errors.collect('commGN')" v-validate="'required'"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs6>
                  <v-text-field v-num-mask v-model="stdCommDiscRateForm.commPct" :label="labels.commPct" :error-messages="errors.collect('commPct')" data-vv-name="commPct" :data-vv-as="labels.commPct" v-validate="'required|mask_decimal:2|mask_min_value:0|mask_max_value:100.00'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox :label="labels.protComm" v-model="stdCommDiscRateForm.protComm" data-vv-name="protComm" :data-vv-as="labels.protComm"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs6>
                  <v-text-field v-num-mask v-model="stdCommDiscRateForm.discPct" :label="labels.discPct" :error-messages="errors.collect('discPct')" data-vv-name="discPct" :data-vv-as="labels.discPct" v-validate="'required|mask_decimal:2|mask_min_value:0|mask_max_value:100.00'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox :label="labels.protDisc" v-model="stdCommDiscRateForm.protDisc" data-vv-name="protDisc" :data-vv-as="labels.protDisc"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
                {{newStdCommDiscRate? 'Add Standard Comm/Disc Rate' : 'Update Standard Comm/Disc Rate'}}
                <v-icon right>{{newStdCommDiscRate? 'mdi-sale' : 'mdi-content-save'}}</v-icon>
                </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { PRODUCT_STDCOMMDISCFACT_TABMENU } from '@/store/types'
import { formatDisplayTime, formatDisplayDateTime2 } from '@/utils/date'
import toDate from 'date-fns/toDate'
import { appID } from '@/const/underwriting'

export default {
  data() {
    return {
      labels: {
        effDate: 'Effective Date*',
        effTime: 'Time*',
        effDateQuery: 'Effective Date',
        endDate: 'End Date',
        endTime: 'Time',
        fact1: 'Factor 1 Value',
        fact2: 'Factor 2 Value',
        fact3: 'Factor 3 Value',
        fact4: 'Factor 4 Value',
        fact5: 'Factor 5 Value',
        fact6: 'Factor 6 Value',
        commGN: 'Commission Gross/Net*',
        commPct: 'Commission %',
        discPct: 'Discount %',
        protComm: 'Protect Commision',
        protDisc: 'Protect Discount'
      },
      stdCommDiscRateForm: {
        product: undefined,
        effDate: undefined,
        endDate: undefined,
        fact1: 'NA',
        fact2: 'NA',
        fact3: 'NA',
        fact4: 0.00,
        fact5: 0.00,
        fact6: 0.00,
        commGN: undefined,
        commPct: undefined,
        discPct: undefined,
        protComm: false,
        protDisc: false,
        revision: undefined
      },
      effDate: undefined,
      effTime: undefined,
      endDate: undefined,
      endTime: undefined,
      menu: [],
      newStdCommDiscRate: false,
      submitting: false,
      gnList: [
        { label: 'Gross', value: 'G' },
        { label: 'Net', value: 'N' }
      ],
      busClsList: [],
      schemeList: [],
      planList: [],
      areaList: [],
      busClsLoading: false,
      schemeLoading: false,
      planLoading: false,
      areaLoading: false
    }
  },
  computed: {
    productAppID() {
      return this.$store.state.productManagement.product.appID
    },
    factor1to3List() {
      return this.$store.state.productManagement.product.factor1to3List
    },
    factor4to6List() {
      return this.$store.state.productManagement.product.factor4to6List
    },
    stdCommDiscFactorEffDate() {
      return this.$store.state.productManagement.product.stdCommDiscFactorEffDate
    },
    stdCommDiscFactors() {
      return this.$store.state.productManagement.product.stdCommDiscFactors
    },
    endDateValidation() {
      return 'start_enddate:' + this.stdCommDiscRateForm.effDate
    },
    factValueLoading() {
      if (this.busClsLoading || this.schemeLoading || this.planLoading || this.areaLoading) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    async doInit() {
      if (!this.newStdCommDiscRate) {
        // Review
        await this.reviewStandardCommDiscRate()
      } else {
        await Promise.all([this.getProductBusClses(), this.getProductSchemes(), this.getPkgPlans(), this.getTravelAreas()])
      }
    },
    async reviewStandardCommDiscRate() {
      const apiURI = this.$store.state.productManagement.product.menu.stdCommDiscRateGet
      if (apiURI) {
        try {
          const expand = {
            product: this.product,
            effDate: formatDisplayDateTime2(this.stdCommDiscRateForm.effDate),
            fact1: this.stdCommDiscRateForm.fact1,
            fact2: this.stdCommDiscRateForm.fact2,
            fact3: this.stdCommDiscRateForm.fact3,
            fact4: this.stdCommDiscRateForm.fact4,
            fact5: this.stdCommDiscRateForm.fact5,
            fact6: this.stdCommDiscRateForm.fact6
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Standard Comm/Disc Factor init
            this.stdCommDiscRateForm.product = data.stdCommDiscRate.product
            this.stdCommDiscRateForm.effDate = data.stdCommDiscRate.effDate
            this.stdCommDiscRateForm.endDate = data.stdCommDiscRate.endDate
            this.stdCommDiscRateForm.fact1 = data.stdCommDiscRate.fact1
            this.stdCommDiscRateForm.fact2 = data.stdCommDiscRate.fact2
            this.stdCommDiscRateForm.fact3 = data.stdCommDiscRate.fact3
            this.stdCommDiscRateForm.fact4 = data.stdCommDiscRate.fact4
            this.stdCommDiscRateForm.fact5 = data.stdCommDiscRate.fact5
            this.stdCommDiscRateForm.fact6 = data.stdCommDiscRate.fact6
            this.stdCommDiscRateForm.commGN = data.stdCommDiscRate.commGN
            this.stdCommDiscRateForm.commPct = data.stdCommDiscRate.commPct
            this.stdCommDiscRateForm.discPct = data.stdCommDiscRate.discPct
            this.stdCommDiscRateForm.protComm = data.stdCommDiscRate.protComm
            this.stdCommDiscRateForm.protDisc = data.stdCommDiscRate.protDisc
            this.stdCommDiscRateForm.revision = data.stdCommDiscRate.revision
            if (this.stdCommDiscRateForm.effDate) {
              this.effDate = this.stdCommDiscRateForm.effDate
              this.effTime = formatDisplayTime(this.stdCommDiscRateForm.effDate)
            }
            if (this.stdCommDiscRateForm.endDate) {
              this.endDate = this.stdCommDiscRateForm.endDate
              this.endTime = formatDisplayTime(this.stdCommDiscRateForm.endDate)
            } else {
              this.endTime = '00:00'
            }

            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getProductBusClses() {
      const apiURI = this.$store.state.productManagement.product.menu.productBusClsesGet
      if (apiURI) {
        try {
          this.busClsLoading = true
          const expand = {
            product: this.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            if (result.data.totalElements > 0) {
              const { data } = result.data
              data.map((productBusCls) => {
                const convertProductBusCls = {
                  value: productBusCls.value,
                  label: productBusCls.label
                }
                this.busClsList.push(convertProductBusCls)
              })
            } else {
              this.busClsList = []
            }
          } else {
            this.busClsList = []
          }
          this.busClsLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.busClsLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getProductSchemes() {
      const apiURI = this.$store.state.productManagement.product.menu.productSchemesGet
      if (apiURI) {
        try {
          this.schemeLoading = true
          const expand = {
            product: this.product,
            appId: this.productAppID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            if (result.data.totalElements > 0) {
              const { data } = result.data
              data.map((productScheme) => {
                const convertProductScheme = {
                  value: productScheme.value,
                  label: productScheme.label
                }
                this.schemeList.push(convertProductScheme)
              })
            } else {
              this.schemeList = []
            }
          } else {
            this.schemeList = []
          }
          this.schemeLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.schemeLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getPkgPlans() {
      const apiURI = this.$store.state.productManagement.product.menu.pkgPlansGet
      if (apiURI) {
        try {
          this.planLoading = true
          const expand = {
            product: this.product,
            appId: this.productAppID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            if (result.data.totalElements > 0) {
              const { data } = result.data
              data.map((pkgPlan) => {
                const convertPkgPlan = {
                  value: pkgPlan.value,
                  label: pkgPlan.label
                }
                this.planList.push(convertPkgPlan)
              })
            } else {
              this.planList = []
            }
          } else {
            this.planList = []
          }
          this.planLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.planLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getTravelAreas() {
      const apiURI = this.$store.state.productManagement.product.menu.productTravelAreasGet
      if (apiURI) {
        try {
          this.areaLoading = true
          const expand = {
            product: this.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            if (result.data.totalElements > 0) {
              const { data } = result.data
              data.map((travelArea) => {
                const convertTravelArea = {
                  value: travelArea.value,
                  label: travelArea.label
                }
                this.areaList.push(convertTravelArea)
              })
            } else {
              this.areaList = []
            }
          } else {
            this.areaList = []
          }
          this.areaLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.areaLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newStdCommDiscRate) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.menu.update
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.stdCommDiscRateForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            const commitData = {
              stdCommDiscFactTab: 1,
              displayFactReviewTab: true,
              displayRateTab: false
            }
            this.$store.commit(PRODUCT_STDCOMMDISCFACT_TABMENU, commitData)
            if (this.productAppID === appID.MOTOR) {
              this.$router.push({ name: 'motorStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
            } else if (this.productAppID === appID.TRAVEL) {
              this.$router.push({ name: 'travelStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
            } else if (this.productAppID === appID.FIRE) {
              this.$router.push({ name: 'fireStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
            } else if (this.productAppID === appID.CARGO) {
              this.$router.push({ name: 'cargoStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
            } else if (this.productAppID === appID.MAID) {
              this.$router.push({ name: 'maidStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
            } else if (this.productAppID === appID.PACKAGE) {
              this.$router.push({ name: 'packageStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doCreate() {
      const apiURI = this.$store.state.productManagement.product.menu.stdCommDiscRateCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.stdCommDiscRateForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)

            // Stay on page
            this.newStdCommDiscRate = false
            const commitData = {
              stdCommDiscFactTab: 1,
              displayFactReviewTab: true,
              displayRateTab: false
            }
            this.$store.commit(PRODUCT_STDCOMMDISCFACT_TABMENU, commitData)
            if (this.productAppID === appID.MOTOR) {
              this.$router.push({ name: 'motorStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
            } else if (this.productAppID === appID.TRAVEL) {
              this.$router.push({ name: 'travelStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
            } else if (this.productAppID === appID.FIRE) {
              this.$router.push({ name: 'fireStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
            } else if (this.productAppID === appID.CARGO) {
              this.$router.push({ name: 'cargoStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
            } else if (this.productAppID === appID.MAID) {
              this.$router.push({ name: 'maidStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
            } else if (this.productAppID === appID.PACKAGE) {
              this.$router.push({ name: 'packageStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    fact1to3Search(fact) {
      if (fact === null) {
        return null
      } else {
        var found = this.factor1to3List.find(function (element) {
          return element.value === fact
        })
        if (found) {
          return found.label
        } else {
          return null
        }
      }
    },
    fact4to6Search(fact) {
      if (fact === null) {
        return null
      } else {
        var found = this.factor4to6List.find(function (element) {
          return element.value === fact
        })
        if (found) {
          return found.label
        } else {
          return null
        }
      }
    },
    factor1to3ValueListSearch(fact) {
      if (fact === null) {
        return null
      } else {
        if (fact === 'BCLS') {
          return this.busClsList
        } else if (fact === 'SCHM') {
          return this.schemeList
        } else if (fact === 'PLAN') {
          return this.planList
        } else if (fact === 'GEOG') {
          return this.areaList
        } else {
          return null
        }
      }
    },
    doEffDate() {
      // Format Effective Date
      if (this.effDate && this.effTime && this.effTime.length === 5) {
        const hr = this.effTime.substring(0, 2)
        const min = this.effTime.substring(3, 5)
        this.effDate = toDate(this.effDate)
        this.effDate.setHours(hr)
        this.effDate.setMinutes(min)
        this.stdCommDiscRateForm.effDate = this.effDate
      }
    },
    doEndDate() {
      // Format Expiry Date
      if (this.endDate && this.endTime && this.endTime.length === 5) {
        const hr = this.endTime.substring(0, 2)
        const min = this.endTime.substring(3, 5)
        this.endDate = toDate(this.endDate)
        this.endDate.setHours(hr)
        this.endDate.setMinutes(min)
        this.stdCommDiscRateForm.endDate = this.endDate
      } else {
        this.stdCommDiscRateForm.endDate = undefined
      }
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    }
  },
  created() {
    if (this.rateId === 'New') {
      this.newStdCommDiscRate = true
      this.stdCommDiscRateForm.product = this.product
      this.effTime = '00:00'
      this.endTime = '00:00'
    } else {
      this.stdCommDiscRateForm.product = this.product
      if (this.rateId) {
        this.stdCommDiscRateForm.effDate = this.rateId.effDate
        this.stdCommDiscRateForm.fact1 = this.rateId.fact1
        this.stdCommDiscRateForm.fact2 = this.rateId.fact2
        this.stdCommDiscRateForm.fact3 = this.rateId.fact3
        this.stdCommDiscRateForm.fact4 = this.rateId.fact4
        this.stdCommDiscRateForm.fact5 = this.rateId.fact5
        this.stdCommDiscRateForm.fact6 = this.rateId.fact6
      }
    }
    this.doInit()
  },
  props: {
    product: {
      type: String,
      default: ''
    },
    rateId: {
      type: [Object, String],
      default: () => { }
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
